// extracted by mini-css-extract-plugin
export default {"placeholder":"FolderPlaceholderItem_placeholder__5THnU","text":"FolderPlaceholderItem_text__7i9WH","indicator":"FolderPlaceholderItem_indicator__2mS8G"};